import serviceRequest from "utils/request";

const baseUrl = "/api/bookrequest";

export const getUserProjects = () => {
	return serviceRequest({
		url: `${baseUrl}/get-user-projects`,
		method: "get",
	});
};
export const getBookRequestUserProjects = (data) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-user-projects`,
		method: "post",
		data,
	});
};

export const getAddProjects = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-add-projects`,
		method: "get",
		params,
	});
};

export const getCapacityFull = (params) => {
	return serviceRequest({
		url: `${baseUrl}/capacity-full`,
		method: "get",
		params,
	});
};

export const getIsReportOutstanding = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-is-report-outstanding`,
		method: "get",
		params,
	});
};

export const getUserBookings = (params) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-user-bookings`,
		method: "get",
		params,
	});
};

export const getAllUserBookings = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-alluser-bookings`,
		method: "get",
		params,
	});
};

export const getReleaseTime = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-release-time`,
		method: "post",
		data,
	});
};

export const bookingSubmit = (data) => {
	return serviceRequest({
		url: `${baseUrl}/v3/booking-submit`,
		method: "post",
		data,
	});
};

export const getUserBookingHistorys = (params) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-user-booking-historys`,
		method: "get",
		params,
	});
};
